import React from "react";
import styled from "@emotion/styled";

import BenefitsCard from "@components/benefits-card";
import { useTranslations } from "next-intl";

function Benefits() {
  const translation = useTranslations("franchise.benefits");

  const benefitsArray = [
    {
      title: translation("risk"),
      img: {
        src: "/icons/remaxrd_inversion_icon.svg",
        alt: "Icono Inversiones",
      },
      text: translation("riskInfo"),
    },
    {
      title: translation("promotion"),
      img: {
        src: "/icons/remaxrd_promocion_icon.svg",
        alt: "Icono Promociones",
      },
      text: translation("promotionInfo"),
    },
    {
      title: translation("training"),
      img: {
        src: "/icons/remaxrd_capacitacion_icon.svg",
        alt: "Icono Capacitación",
      },
      text: translation("trainingInfo"),
    },
    {
      title: translation("technology"),
      img: {
        src: "/icons/remaxrd_recursos_icon.svg",
        alt: "Icono Recursos",
      },
      text: [translation("technologyInfo"), translation("technologyInfoTwo")],
    },
    {
      title: translation("network"),
      img: {
        src: "/icons/remaxrd_red_icon.svg",
        alt: "Icono Red",
      },
      text: translation("networkInfo"),
    },
    {
      title: translation("support"),
      img: {
        src: "/icons/remaxrd_asistencia_icon.svg",
        alt: "Icono Asistencia",
      },
      text: translation("supportInfo"),
    },
  ];

  return (
    <Wrapper>
      <BenefitsContainer className="container">
        {benefitsArray.map((benefit, index) => (
          <BenefitsCard {...benefit} as="article" key={index} />
        ))}
      </BenefitsContainer>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  background-color: var(--color-brand-cream-primary);
  border-radius: 200px 200px 0px 0px;
  padding: 140px 0 50px;
  position: relative;
  z-index: 20;

  @media screen and (max-width: 991px) {
    border-radius: 0px;
    z-index: 0;
  }
`;

const BenefitsContainer = styled.div`
  display: grid;
  grid-template: auto / auto auto auto;
  gap: 20px;
  place-content: center;

  @media screen and (max-width: 991px) {
    grid-template: auto / auto auto;
  }

  @media screen and (max-width: 767px) {
    grid-template: auto / auto;
  }
`;

export default Benefits;
